import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { UserRecord } from '@tassat/fred-definitions';
import { AddSmall as AddSmallIcon } from '@tassat/icon';
import React from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface IPageHeaderTitleProps {
    title: string;
    form?: boolean;
    onClick?: (e?) => void;
    className?: string;
    currentUser?: UserRecord;
    children?: React.ReactNode;
}

export function PageHeaderTitle(props: IPageHeaderTitleProps) {
    const {
        className,
        title = '---',
        form,
        onClick,
        children
    } = props;

    const muiStyles = makeStyles((theme: ApplicationMuiTheme) => ({
        container: {
            width: '100%',
            padding: '1.9rem 0',
            paddingLeft: '2rem'
        },
        text: {
            marginRight: '1.25rem',
            color: theme?.app?.clientTheme.colors.primaryColor ||
                '#375073',
            fontSize: '1.6rem',
            fontWeight: 500,
            fontFamily: 'corporate-s,sans-serif'
        },
        actionIcon: {
            height: '28px',
            width: '28px',
            cursor: 'pointer',
            borderRadius: '6px',
            '& g': {
                fill: theme?.app?.clientTheme.colors.primaryColor ||
                    '#375073',
                '&:hover': {
                    fill: theme?.app?.clientTheme.colors.primaryColorLight ||
                        'rgb(0, 155, 223)',
                    backgroundColor: theme?.app?.applicationColors.backgroundPrimary ||
                        '#fff'
                }
            }
        },
        filterDropdown: {
            display: 'flex',
            width: '50%',
            'align-items': 'center',
            'margin-bottom': '0px'
        },
        currencyContainer: {
            display: 'flex',
            width: '50%',
            'margin-left': '5%',
            'align-items': 'center',
            'justify-content': 'flex-start'
        },
        btnRequestContainer: {
            display: 'flex' as const,
            alignItems: 'center' as const,
            justifyContent: 'center' as const
        },
        btnRequest: {
            height: '28px',
            background: '#E68856',
            color: '#fff',
            fontSize: '14px',
            fontWeight: 'normal' as const,
            padding: '17px',
            textTransform: 'capitalize' as const,
            margin: '10px -1rem',
            '&:hover': {
                background: '#fff',
                color: '#E68856',
                borderColor: '#E68856',
                outline: '2px solid'
            }
        }
    }));

    const {
        container,
        text,
        actionIcon
    } = muiStyles(props);

    return (
        <Grid
            alignItems='center'
            className={`${className} ${container}`}
            container
            justifyContent='space-between'
        >
            <Grid
                container
                direction='row'
                item
                xs={5}
            >
                <Typography
                    className={text}
                    variant='h4'
                >
                    {title}
                </Typography>
                {form &&
                    <AddSmallIcon
                        className={actionIcon}
                        id='pageHeaderAddEntityButton'
                        onClick={onClick}
                    />}
            </Grid>
            {children}
        </Grid>
    );
}

export default PageHeaderTitle;